import React, { useState } from 'react';
import styles from './NewPassword.module.css';
import axios from 'axios';
import logo from '../../../../assets/imgs/Odoo-Feelancer-LOGO.png';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { FaEye, FaEyeSlash } from "react-icons/fa";

const NewPassword = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const temp_id = searchParams.get('temp_id');
  const temp = searchParams.get('temp');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.info('Passwords do not match');
      return;
    }

    if (loading) {
      return; 
    } 
    setLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/reset_password`, {
        temp_id,
        temp,
        password,
        c_password: confirmPassword,
      });
      console.log("response in new password ====================", response);

      if (response.data.result.status === 'success') {
        toast.success('Password updated successfully');
        setTimeout(() => {
          navigate('/');
        }, 3000);
      } else {
        toast.error(response.data.result.message);
      }
    } catch (error) {
      toast.error('An error occurred. Please try again.');
    } finally { 
      setLoading(false); 
    }
  };

  const handleCancel = () => {
    navigate('/');
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.logo}>
          <img style={{ height: '80px' }} src={logo} alt="Logo" />
        </div>
      </header>
      <div className={styles.card}>
        <h2>Update Your Password</h2>
        <form className={styles.form} onSubmit={handleSubmit}>
          <div>
            <label htmlFor="password" className={styles.formLabel}>
              New Password
            </label>
            <div className={styles.passwordInputWrapper}>
              <input
                type={passwordVisible ? "text" : "password"}
                id="password"
                placeholder="New Password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={styles.formInput}
              />
              <button
                type="button"
                className={styles.passwordToggle}
                onClick={togglePasswordVisibility}
                aria-label={passwordVisible ? "Hide password" : "Show password"}
              >
                {passwordVisible ? <FaEye /> : <FaEyeSlash />}
              </button>
            </div>
          </div>

          <div>
            <label htmlFor="confirm-password" className={styles.formLabel}>
              Confirm New Password
            </label>
            <div className={styles.passwordInputWrapper}>
              <input
                type={confirmPasswordVisible ? "text" : "password"}
                id="confirm-password"
                placeholder="Confirm Password"
                required
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className={styles.formInput}
              />
              <button
                type="button"
                className={styles.passwordToggle}
                onClick={toggleConfirmPasswordVisibility}
                aria-label={
                  confirmPasswordVisible ? "Hide password" : "Show password"
                }
              >
                {confirmPasswordVisible ? <FaEye /> : <FaEyeSlash />}
              </button>
            </div>
          </div>
          <div className={styles.buttons}>
            <button type="button" className={styles.cancelButton} onClick={handleCancel}>
              Cancel
            </button>
            <button type="submit" className={styles.resetButton} disabled={loading}>
              {loading ? 'Updating...' : 'Update Password'}
            </button>
          </div>
        </form>
      </div>
      <footer className={styles.footer}>
        <p>
          © 2024 Odoo. <a href="/privacy-policy" className={styles.footerLink}>Privacy Policy</a>
        </p>
      </footer>
      <ToastContainer />
    </div>
  );
};

export default NewPassword;
